<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <!-- <el-card style="max-height:340px">
              <Leftbar></Leftbar>
            </el-card> -->
            <el-card class="rightContent">
              <h3>
                {{ $t("classList.myClass") }}
                <span style="float: right">
                  <el-button
                    type="primary"
                    @click="joinClassDialogVisible = true"
                  >
                    {{ $t("classList.joinClass") }}</el-button
                  >
                </span>
              </h3>
              <el-divider></el-divider>
              <el-table
                ref="filterTable"
                :data="classList"
                style="width: 100%"
                v-loading="loading"
              >
                <el-table-column
                  prop="name"
                  :label="$t('table.class')"
                  min-width="80%"
                >
                </el-table-column>
                <el-table-column
                  prop="delete"
                  :label="$t('table.operation')"
                  min-width="20%"
                >
                  <template slot-scope="scope">
                    <el-button
                      @click="goClassDetail(scope.row)"
                      type="primary"
                      size="small"
                      >{{ $t("button.look") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!--              <el-pagination-->
              <!--                background-->
              <!--                layout="prev, pager, next"-->
              <!--                :total="totalPage"-->
              <!--                style="float:right;margin:20px"-->
              <!--                :current-page.sync="currentPage"-->
              <!--              >-->
              <!--              </el-pagination>-->
            </el-card>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('classList.joinClassL')"
      :visible.sync="joinClassDialogVisible"
      width="30%"
    >
      <el-form
        style="margin-top: 20px"
        :model="joinClassForm"
        ref="joinClassForm"
        label-position="left"
        label-width="100px"
        @submit.native.prevent
      >
        <el-form-item
          :label="$t('classList.teacherName')"
          prop="managerName"
          :rules="[{ required: true, message: $t('common.notNull') }]"
        >
          <el-input
            :placeholder="$t('classList.inputTeacher')"
            v-model="joinClassForm.managerName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('classList.classId')"
          prop="classId"
          :rules="[{ required: true, message: $t('common.notNull') }]"
        >
          <el-input
            :placeholder="$t('classList.inputId')"
            v-model="joinClassForm.classId"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="joinClassDialogVisible = false">{{
          $t("button.cancel")
        }}</el-button>
        <el-button type="primary" @click="joinClass">{{
          $t("button.join")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 优化点
import Leftbar from "../../components/newComponent/Leftbar";
import { myClassListGet, joinInClass } from "../../api/class";

export default {
  components: {
    Leftbar,
  },
  name: "class",
  bodyClass: "index-page",
  data() {
    return {
      classList: [],
      classNameToCreate: "",
      createClassDialogVisible: false,
      joinClassDialogVisible: false,
      classKeyword: "",
      totalPage: 1,
      isManager: true,
      currentPage: 1,
      loading: false,
      selectedClass: {},

      //join
      joinClassForm: {
        captcha: "",
        classId: "",
        managerName: "",
      },
    };
  },
  mounted() {
    this.initClassList();
  },
  methods: {
    initClassList() {
      myClassListGet(localStorage.getItem("uid")).then((res) => {
        this.classList = res;
      });
    },
    joinClass() {
      let that = this;
      this.$refs["joinClassForm"].validate().then((valid) => {
        if (valid) {
          joinInClass(
            localStorage.getItem("uid"),
            this.joinClassForm.classId,
            this.joinClassForm.managerName,
          )
            .then((res) => {
              if (res.allowJoin) {
                this.joinClassDialogVisible = false;
                this.$notify({
                  type: "success",
                  title: that.$t("common.success"),
                  duration: 3000,
                });
              }
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.$notify({
                  type: "error",
                  title: that.$t("common.fail"),
                  duration: 3000,
                  message: that.$t("classList.joinError"),
                });
              }
              if (error.response.status === 403) {
                this.$notify({
                  type: "error",
                  title: that.$t("common.fail"),
                  duration: 3000,
                  message: that.$t("classList.allowJoinError"),
                });
              }
            });
        }
      });
    },
    changeSelectedClass(row) {
      this.joinClassDialogVisible = true;
      this.selectedClass = row;
    },
    goClassDetail(row) {
      this.$router.push("/class/detail/" + row.id);
    },
  },
  computed: {},
  watch: {
    currentPage(newVal, old) {
      this.searchClass();
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
